export const defaultState = () => ({
	step: 0,
	forward: true,
	complete: false,
	extraFeatures: [],
});

const state = defaultState();

export default state;
